import { render } from "./BaseButton.vue?vue&type=template&id=6053377c&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=6053377c&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6053377c"]])

export default __exports__